<template lang="pug">
  FormModal(title="Edit Global Tag", :endpoint="endpoint", method="PUT", :data="data", v-bind="$attrs", @success="success")
    Alert.mb-4(v-if="scanned && scanned.exists", type="info")
      | #[strong {{ scanned.partners }}] partner{{ scanned.partners === 1 ? ' is' : 's are' }} using the #[strong.underline {{ scanned.tag}}] tag across #[strong {{ scanned.collections }}] content experience{{ scanned.collections === 1 ? '' : 's' }}.
    Alert.mb-4(v-if="scanned && !scanned.exists", type="warning")
      | No partners are using the tag #[strong.underline {{ scanned.tag}}].
    InputGroup(label="Tag", name="name"): TextInput(v-model="data.name", prepend-icon="tag", @change="scanTag()")
</template>

<script>
import { debounce } from "lodash-es"
import { Alert } from "@syntax51/app-kit"
import { EditModalMixin } from "@syntax51/app-kit"

export default {
  mixins: [EditModalMixin],
  components: {
    Alert
  },
  data: () => ({
    data: {
      name: ""
    },
    scanned: null
  }),
  methods: {
    success() {
      this.$notification.success(`Global tag **${this.data.name}** successfully updated.`)
      this.$emit("close", true)
    },
    scanTag: debounce(async function (tag) {
      this.scanned = null
      const response = await this.$api.get(`global-tags/scan?name=${tag}`)
      this.scanned = response?.data
    }, 500)
  },
  watch: {
    "data.name": function (newVal) {
      this.scanTag(newVal)
    }
  }
}
</script>
